<template>
  <div class="m-2">
    <h1>Language tool</h1>
    <div v-if="isLoading" class="text-center py-5">
      <b-spinner large variant="primary" label="Loading translations..."></b-spinner>
      <p class="mt-3">Indlæser oversættelser...</p>
    </div>
    <template v-else>
      <translation-level
        v-for="(value, attr) in translationTree"
        :key="attr"
        :attr="attr"
        :value="value"
        :secret="secret"
        @translation-updated="handleTranslationUpdate"
      />
    </template>
  </div>
</template>

<script>
import { BCard, BSpinner } from "bootstrap-vue";
import ResourceService from "@/services/base/resource.service";
import TranslationLevel from "./TranslationLevel.vue";

export default {
  components: {
    BCard,
    BSpinner,
    TranslationLevel,
  },
  data() {
    return {
      secret: "",
      translationItems: [],
      isLoading: false,
    };
  },
  async created() {
    await this.fetchTranslations();
  },
  computed: {
    translationTree() {
      const tree = {};

      for (const item of this.translationItems) {
        const keys = item.key.split(".");
        let currentNode = tree;

        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          if (!currentNode[key]) {
            currentNode[key] = {};
          }
          currentNode = currentNode[key];

          if (i === keys.length - 1) {
            if (!currentNode.rows) {
              currentNode.rows = [];
            }
            const row = { key: keys[keys.length - 1], value: item.value };
            for (const attribute in item) {
              if (attribute !== "key" && attribute !== "value") {
                row[attribute] = item[attribute];
              }
            }
            currentNode.rows.push(row);
          }
        }
      }

      return tree;
    },
  },
  methods: {
    async fetchTranslations() {
      try {
        this.isLoading = true;
        this.secret = this.$route.params.secret;
        const service = new ResourceService("translations/items");
        this.translationItems = (await service.get(`s/${this.secret}`)).data.data;
      } catch (error) {
        this.$bvToast.toast(error.message || "Kunne ikke indlæse oversættelser", {
          title: "Fejl ved indlæsning af oversættelser",
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
      } finally {
        this.isLoading = false;
      }
    },
    handleTranslationUpdate(event) {
      const { success, message } = event;
      this.$bvToast.toast(message, {
        title: success ? "Oversættelse opdateret" : "Opdatering fejlede",
        variant: success ? "success" : "danger",
        solid: true,
        autoHideDelay: success ? 3000 : 5000,
      });
    },
  },
};
</script>